// @ts-check
import React, { useState, useEffect, useContext, useMemo } from "react";
import PropTypes from "prop-types";
//
import { useNavigate } from "react-router";
import { useIntl } from "react-intl";
//
import Box from "@mui/material/Box";
import Link from "@mui/material/Link";
import Typography from "@mui/material/Typography";
import IconButton from "@mui/material/IconButton";
import MinimizeIcon from "@mui/icons-material/Minimize";
import CropSquareIcon from "@mui/icons-material/CropSquare";
import HelpOutlineIcon from "@mui/icons-material/HelpOutline";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import CloseIcon from "@mui/icons-material/Close";
import { styled } from "@material-ui/styles";
// component, hooks
// @ts-ignore
import { isArray } from "lodash";
import DragHandleIcon from "@mui/icons-material/DragHandle";
import DraggableWindow from "../../../../../common/components/draggable/DraggableWindow";
import BasicTable from "./template/BasicTable";
import useDraggable from "./useDraggable";
import ButtonMain from "../../../../../common/components/button/ButtonMain";
// store
import { StoreContext } from "../../../../../store/StoreProvider";
import Act from "../../../../../store/actions";
// config,utils
import GraphAnalysis from "../../../../../common/utils/snaAnalysis/snaAnalysis";
// eslint-disable-next-line import/named
import {
  SNA_ANALYTICS_TYPE,
  SNA_ANALYTICS_DESC,
  SNA_ANALYTICS_LINK,
} from "../../../../../config/config.sna";
import { SNA_MAIN_ID, SNA_WRAPPER_DIV_ID } from "../../../config";
import { headers } from "./option";
import chartIcon from "../../../../../../images/icon_chart/icon_chart.svg";

import { getRows } from "../../../service/datasetService";
//

// style
const StyledBox = styled(Box)(({ theme }) => ({
  "&:hover": {
    cursor: "pointer",
  },
}));

/**
 *
 * @type {null|import('../../../../../common/utils/snaAnalysis/snaAnalysis').default}
 */
let graph = null;

/**
 * react-rnd 物件
 * @typedef RndRef {object}
 * @property {function({width:number,height:number}):void} updateSize
 * @property {function({x:number,y:number}):void} updatePosition
 */

/**
 * react-rnd ref
 * @type {null|RndRef}
 */
let rndRef = null;

const defaultSize = {
  width: 200,
  height: 40,
};

const defaultPosition = {
  x: 0,
  y: 0,
};

const defaultMaxSize = {
  width: 600,
  height: 680,
};

const defaultBounds = {
  ...defaultPosition,
  width: 500,
  height: 500,
};

const DRAG_HANDLER_CLASS = "anlytics_drag_handler";

/**
 * 使用 拖曳視窗,顯示分析結果(page0)及分析標的說明(page1)
 * @returns {JSX.Element}
 * @constructor
 */
const AnalyticsResult = () => {
  // props

  // route,intl
  const intl = useIntl();
  const navigate = useNavigate();
  // store

  // @ts-ignore
  const [state, dispatch] = useContext(StoreContext);
  const { sna } = state;
  const { snaDisplay, analytics } = sna;
  const {
    drawNetworkData: { links, nodes },
    memoSnaWidth,
    memoSnaHeight,
  } = snaDisplay || {};
  const { analyticsType, startAnalysis, displayWindow } = analytics;

  // local state
  const [rows, setRows] = useState([]);
  // DraggableWindow component 的 default props
  const dragDefault = {
    ...defaultSize,
    ...defaultPosition,
  };
  // dragSize updated
  const [dragSize, setDragSize] = useState({
    ...defaultSize,
  });
  // dragPosition updated
  const [dragPosition, setDragPosition] = useState({
    ...defaultPosition,
  });
  // 邊界: DraggableWindow 的邊界 {x:number,y:number,width:number,height:number}
  const [bounds, setBounds] = useState({
    ...defaultBounds,
  });
  const [pageIdx, setPageIdx] = useState(0);
  // hook
  const {
    onDrag,
    onDragStop,
    onResize,
    askForWindowOpen,
    setDragMiniSize,
    setDragMaxSize,
  } = useDraggable({
    dragPosition,
    setDragPosition,
    dragSize,
    setDragSize,
    bounds,
    rndRef,
    dragEles: [DRAG_HANDLER_CLASS],
    dispatch,
    intl,
    defaultSize,
    defaultMaxSize,
    memoSnaWidth,
    memoSnaHeight,
  });

  // 當 sna 繪圖區的 width 及 height 改變時,設定 bounds
  useEffect(() => {
    if (!(memoSnaWidth == null) && !(memoSnaHeight == null)) {
      setBounds({
        ...bounds,
        width: memoSnaWidth,
        height: memoSnaHeight,
      });
      // 將拖曳視窗放到最大
      if (displayWindow) {
        setDragMaxSize();
      }
    }
  }, [memoSnaWidth, memoSnaHeight]);

  useEffect(() => {
    // 若開啟視窗,則最大化
    if (displayWindow) {
      setDragMaxSize();
    }
  }, [displayWindow]);

  // /**
  //  * get top list
  //  * @param list {*[]}
  //  * @param num {number}
  //  *
  //  * @returns {*}
  //  */
  // const topList = (list, num = 5) => isArray(list) && list.slice(0, num);

  /**
   * 取得要顯示的資料
   * @returns {[]|import("../../../../../common/utils/snaAnalysis/snaAnalysis").ValueList|any}
   */
  // const getRows = () => {
  //   if (!graph) return [];
  //   // 效能:graph instance 有記憶的功能,若已經計算過的數值會儲存起來,下次可以直接取用
  //   // return fakeRows;
  //   switch (analyticsType.initial) {
  //     case SNA_ANALYTICS_TYPE.degreeCentrality.key:
  //       return graph.getDegreeCentrality();
  //     case SNA_ANALYTICS_TYPE.degreeCentralityStd.key:
  //       return graph.getDegreeCentralityStd();
  //     case SNA_ANALYTICS_TYPE.betweenCentrality.key:
  //       return graph.getBetweenCentrality();
  //     case SNA_ANALYTICS_TYPE.betweenCentralityStd.key:
  //       return graph.getBetweenCentralityStd();
  //     case SNA_ANALYTICS_TYPE.closeCentrality.key:
  //       return graph.getCloseCentrality();
  //     // case SNA_ANALYTICS_TYPE.eccentriCentrality.key:
  //     //   return graph.getEccentriCentrality();
  //     case SNA_ANALYTICS_TYPE.eigenvectorCentrality.key:
  //       return graph.getEigenvectorCentrality();
  //     case SNA_ANALYTICS_TYPE.pageRank.key:
  //       return graph.getPageRank();
  //     case SNA_ANALYTICS_TYPE.completeAnalysis.key:
  //       return {
  //         degreeCentralityStd: topList(graph.getDegreeCentralityStd()),
  //         betweenCentralityStd: topList(graph.getBetweenCentralityStd()),
  //         closeCentrality: topList(graph.getCloseCentrality()),
  //         eigenvectorCentrality: topList(graph.getEigenvectorCentrality()),
  //       };
  //     default:
  //       return [];
  //   }
  // };

  // 當繪圖區的 network 資料轉換成 links,nodes 格式後,
  // 1.建立 graph instance
  // 2.分析資料
  useEffect(() => {
    if (isArray(links) && isArray(nodes) && analyticsType.initial) {
      graph = new GraphAnalysis(links, nodes);
      // @ts-ignore
      setRows(getRows(graph, analyticsType.initial));
    }
  }, [links, nodes, analyticsType]);

  useEffect(() => {
    if (startAnalysis && analyticsType.initial) {
      // 停止分析
      dispatch({
        type: Act.SNA_ANALYTICS_START_ANALYSIS,
        payload: false,
      });
      dispatch({
        type: Act.SNA_ANALYTICS_DISPLAY_WINDOW,
        payload: true,
      });
      if (graph) {
        // 回到第一頁
        setPageIdx(0);
        // @ts-ignore
        setRows(getRows(graph, analyticsType.initial));
        setDragMaxSize();
      }
    }
  }, [startAnalysis, analyticsType]);

  // 縮小視窗
  const onClickMini = () => {
    setDragMiniSize();
  };

  // 放大視窗
  const onClickMax = () => {
    setDragMaxSize();
  };

  const onClickClose = () => {
    dispatch({
      type: Act.SNA_ANALYTICS_DISPLAY_WINDOW,
      payload: false,
    });
  };

  // 拖曳視窗的 header
  const getDragHeader = (
    <Box display="flex" justifyContent="space-between">
      <Box display="flex" justifyContent="flex-start">
        {/* <IconButton> */}
        {/*  <DragHandleIcon /> */}
        {/* </IconButton> */}
        {/* <IconButton onClick={onClickMini}> */}
        {/*  <MinimizeIcon /> */}
        {/* </IconButton> */}
        {/* <IconButton onClick={onClickMax}> */}
        {/*  <CropSquareIcon /> */}
        {/* </IconButton> */}
      </Box>
      <Box>
        <IconButton onClick={onClickClose} onTouchStart={onClickClose}>
          <CloseIcon />
        </IconButton>
      </Box>
    </Box>
  );

  /**
   * 取得 draggableWindow title
   * @returns {*|string}
   */
  const getTitle = () => {
    const find = Object.values(SNA_ANALYTICS_TYPE).find(
      (o) => o.key === analyticsType.initial
    );
    return find?.label || "";
  };

  /**
   * 取得 draggableWindow title by key
   * @param key {string}
   * @returns {*|string}
   */
  const getTitleByKey = (key) => {
    const find = Object.values(SNA_ANALYTICS_TYPE).find((o) => o.key === key);
    return find?.label || "";
  };

  /**
   * 取得分析項目的說明 link
   * @returns {*|string}
   */
  const getLink = () =>
    // @ts-ignore
    SNA_ANALYTICS_LINK?.[analyticsType.initial];

  const getDragTitle = useMemo(
    () =>
      getTitle() && (
        <Box py={1} display="flex" justifyContent="center" alignItems="center">
          <Typography variant="h6" textAlign="center">
            {getTitle()}
          </Typography>
          {pageIdx === 0 && (
            <IconButton onClick={() => setPageIdx(1)}>
              <HelpOutlineIcon />
            </IconButton>
          )}
        </Box>
      ),
    [analyticsType, pageIdx]
  );

  // @ts-ignore
  const getFallbackText = useMemo(
    () => (
      <Typography variant="body1" component="div">
        請由左側工具選單點選
        <span
          style={{
            position: "relative",
            top: "8px",
            marginLeft: "8px",
            marginRight: "8px",
          }}
        >
          <img src={chartIcon} alt="analytics icon" width={30} />
        </span>
        圖示，選取要分析的類型，數據分析結果會呈現於此處。
      </Typography>
    ),
    []
  );

  /**
   *
   * @param item {any}
   * @returns {*|*[]|null}
   */
  const safeList = (item) =>
    item && Array.isArray(item) ? item : (item && [item]) || [];

  /**
   * @param key {string=} null SNA_ANALYTICS_DESC 的 key
   * @param persons {string=} 人物名稱
   * @returns {*|string}
   */
  const getDescription = (key, persons) => {
    // @ts-ignore
    const descList = safeList(
      // @ts-ignore
      (key && key in SNA_ANALYTICS_DESC && SNA_ANALYTICS_DESC[key]) ||
        // @ts-ignore
        SNA_ANALYTICS_DESC?.[analyticsType.initial]
    );
    /**
     *
     * @param list {string[]|function[]}
     * @returns {unknown[]}
     */
    const strList = (list) =>
      safeList(list).map(
        /**
         *
         * @param l {string|function}
         * @param idx {number}
         * @returns {JSX.Element}
         */
        (l, idx) => {
          if (typeof l === "function") {
            return (
              <Typography
                key={idx.toString()}
                variant="body1"
                // sx={{ color: "#ff5252" }}
                sx={{ color: "#3bbff0" }}
              >
                {persons && l(persons)}
              </Typography>
            );
          }
          return (
            <Typography key={idx.toString()} variant="body1">
              {l}
            </Typography>
          );
        }
      );
    // @ts-ignore
    return (
      // @ts-ignore
      descList.map((txt, idx) => (
        <React.Fragment key={idx.toString()}>
          {strList(txt)}
          {idx < descList.length - 1 && <br />}
        </React.Fragment>
      )) ||
      intl.formatMessage({
        id: "common.wait.info.supply",
        defaultMessage: "待補充相關資訊",
      })
    );
  };

  /**
   * 是否為 object type
   * @param _rows {{} | string[]}
   * @returns {boolean}
   */
  const isRowsMapType = (_rows) =>
    typeof _rows === "object" && !Array.isArray(_rows);

  /**
   * 取得分析結果的前幾名人物字串
   * @param _rows {Object[]}
   * @returns {`${*}及${*}等人`}
   */
  const getKeyPersonStr = (_rows) =>
    `${_rows
      // @ts-ignore
      .slice(0, 2)
      // @ts-ignore
      .map((o) => o.label)
      .join("、")}及${_rows
      // @ts-ignore
      .slice(2, 3)
      // @ts-ignore
      .map((o) => o.label)
      .join("")}等人`;

  // 完整分析的 element
  const getCompleteAnaEle = () =>
    isRowsMapType(rows) && (
      <Box
        sx={{ height: `${defaultMaxSize.height - 100}px`, overflowY: "auto" }}
      >
        {getDragTitle}
        {Object.entries(rows).map(([key, _rows], idx) => (
          <Box key={idx.toString()} mb={2}>
            <Box
              py={1}
              display="flex"
              justifyContent="center"
              alignItems="center"
            >
              <Typography
                variant="h6"
                textAlign="center"
                sx={{ marginBottom: "8px" }}
              >
                {getTitleByKey(key)}
              </Typography>
            </Box>
            <Box>
              <Typography
                variant="body1"
                sx={{ marginBottom: "8px" }}
                component="div"
              >
                {getDescription(key, getKeyPersonStr(_rows))}
              </Typography>
            </Box>
            {/* <BasicTable headers={headers} rows={_rows} /> */}
          </Box>
        ))}
      </Box>
    );

  // 分析結果第 0 頁(結果顯示頁)
  const getPage0 = useMemo(
    () => (
      // 分析結果
      <Box>
        {getDragHeader}
        {(isArray(rows) && rows.length > 0 && (
          <Box py={1} px={3} bgcolor="#fff">
            {getDragTitle}
            <Box>
              <Typography
                variant="body1"
                sx={{ marginBottom: "8px" }}
                component="div"
              >
                {getDescription(analyticsType.initial, getKeyPersonStr(rows))}
              </Typography>
            </Box>
            <BasicTable headers={headers} rows={rows} />{" "}
          </Box>
        )) ||
          (isRowsMapType(rows) && getCompleteAnaEle()) || (
            <Box py={1} px={3} bgcolor="#fff">
              {getDragTitle}
              {getFallbackText}
            </Box>
          )}
      </Box>
    ),
    [headers, rows, memoSnaWidth, memoSnaHeight, pageIdx]
  );

  // 分析結果第 1 頁(補充說明頁)
  const getPage1 = useMemo(
    () => (
      // 分析項目的說明文字
      <Box>
        {getDragHeader}
        <Box py={1} px={3} bgcolor="#fff">
          {getDragTitle}
          <Box py={1}>
            <ButtonMain
              buttonProps={{
                text: intl.formatMessage({
                  id: "common.goto.previous.page",
                  defaultMessage: "回上一頁",
                }),
                variant: "text",
                startIcon: <ArrowBackIcon />,
                onClick: () => setPageIdx(0),
              }}
            />
          </Box>
          {getLink() && (
            <Box py={1}>
              <Link href={getLink()} target="_blank" rel="noreferrer noopenner">
                {intl.formatMessage({
                  id: "common.related.link",
                  defaultMessage: "相關連結",
                })}
              </Link>
            </Box>
          )}
          <Box py={2} minHeight={500}>
            <Typography variant="body1" component="div">
              {getDescription()}
            </Typography>
          </Box>
        </Box>
      </Box>
    ),
    [analyticsType, pageIdx]
  );

  const pages = [getPage0, getPage1];
  const getElement = () => pages?.[pageIdx] || null;

  /**
   * 取得 react-rnd(draggable window)的 ref
   * @param ref {null|RndRef}
   */
  const onDragWindowReady = (ref) => {
    rndRef = ref;
  };

  return (
    <StyledBox
      position="relative"
      left={0}
      top={0}
      height={0}
      display={displayWindow ? "flex" : "none"}
      justifyContent="flex-end"
      zIndex={10}
    >
      <DraggableWindow
        onReady={onDragWindowReady}
        element={getElement()}
        rndDefault={dragDefault}
        // //若有設定 boundingBoxClassName, 則取消 onDrag, onDragStop
        // onDrag={onDrag}
        // onDragStop={onDragStop}
        onResize={onResize}
        minWidth={defaultSize.width}
        minHeight={defaultSize.height}
        maxWidth={defaultMaxSize.width}
        maxHeight={defaultMaxSize.height}
        boundingBoxClassName={`.${SNA_MAIN_ID}`}
      />
    </StyledBox>
  );
};

AnalyticsResult.propTypes = {};

AnalyticsResult.defaultProps = {};

export default AnalyticsResult;
